document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('headerSearchButton');
  const panel = document.getElementById('header-search-panel');

  if (!button || !panel) return;

  function openPanel() {
    panel.hidden = false;
    panel.classList.remove('hidden');

    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');

    // Move focus into the search - disable it for now
    /**
    if (input) {
      requestAnimationFrame(() => input.focus());
    }
    */
  }

  function closePanel() {
    panel.hidden = true;
    panel.classList.add('hidden');

    button.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');

    // Restore focus to the toggle button
    button.focus();
  }

  function togglePanel() {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    isOpen ? closePanel() : openPanel();
  }

  // Toggle on button click
  button.addEventListener('click', e => {
    e.stopPropagation();
    togglePanel();
  });

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
      closePanel();
    }
  });

  // Click outside closes panel
  document.addEventListener('click', e => {
    if (
      button.getAttribute('aria-expanded') === 'true' &&
      !panel.contains(e.target) &&
      !button.contains(e.target)
    ) {
      closePanel();
    }
  });
});
